import * as THREE from 'three';
import {Object3D} from 'three';
import * as TWEEN from "@tweenjs/tween.js";
import {PlayerEvents} from "./event";
import {EventType} from "../enums";

class PlayerAnimations {
    animations: any[] = [];
    event: PlayerEvents;
    constructor( ) {

    }
    // run 是否立即运行
   runObjectAnimation (object: Object3D,run: boolean) {
       if (object.userData === undefined || object.userData === null) {
           return;
       }
       if(object.userData.isText){
           if(Number.isNaN(object.rotation.x)){
               object.rotation.x=0;
           }
           if(Number.isNaN(object.rotation.y)){
               object.rotation.y=0;
           }
           object.quaternion.copy(new THREE.Quaternion());
       }
       if (object.userData.animations && Array.isArray(object.userData.animations)) {
           object.userData.animations.forEach((animation: any) => {
               if (animation.id){
                   this.animations.forEach((an)=>{
                       if (an.getId() == animation.id){
                           an.start()
                       }
                   })
                   return;
               }
               let tween:any
               if (animation.key === "opacity"){
                   if ((object as any).material){
                       (object as any).material.transparent = true
                       tween = new TWEEN.Tween((object as any).material[animation.key]);
                   }
               }else {
                   tween = new TWEEN.Tween((object as any)[animation.key]);
               }
               if (animation.delay !== undefined && animation.delay !== null) {
                   tween.delay(animation.delay);
               }
               tween.to(animation.to, animation.time);
               if (animation.repeat !== undefined && animation.repeat !== null) {
                   if (animation.repeat < 0) {
                       animation.repeat = Infinity;
                   }
                   tween.repeat(animation.repeat);
               }
               if (animation.yoyo === true) {
                   tween.yoyo(true);
               }
               tween.easing(animation.easing);
               if (run || animation.start === true) {
                   tween.start();
               }
               animation.id = tween.getId()
               this.animations.push(tween);
           });


       }
   }

   stopObjectAnimation(object: Object3D){
       if (object.userData === undefined || object.userData === null) {
           return;
       }
       if (object.userData.animations && Array.isArray(object.userData.animations)) {
           object.userData.animations.forEach((animation: any) => {
               // 删除动画
               this.animations.forEach((an)=>{
                   if (an.getId() != animation.id){
                       an.stop()
                       //todo 判断该动画停止是否执行事件
                       //this.event.runObjectEvent(object, EventType.StopAnimation)
                   }
               })
           })
       }
   }
}

export { PlayerAnimations };


export interface Animation {
    delay?: number // 动画延迟
    repeat?: number, // 动画重复次数
    yoyo?: boolean // 往返
    actions?: Array<AnimationAction>   // 并发运行的
}


export interface AnimationAction {
    id?: string    // 动画ID
    type?: number // 动画类型 x,y,z,或透明度
    toValue?: number // 目标值
    duration?: number // 动画时长
}
